/**
 * Mobile navigation logic is here.
 */
export default class MobileNavigation {

  /**
   * @property {Element} element This class only controls elements under this element. It's a scope of this class.
   */
  private element:HTMLElement;

  /**
   * @property {object} dom Items referenced in document object model are stored here.
   */
  private dom:MobileNavigationDomElements = {};

  /**
   * @constructor
   * @param {Element} element main element
   */
  constructor(element:HTMLElement) {
    this.element = element;
    this.findElements();
    this.attacEventListeners();
  }

  /**
   * Find element from DOM and stores them for a later use.
   * @private
   */
  private findElements() {
    this.dom.ul = this.element.querySelector('ul')
  }

  /**
   * Bind event listeners
   * @private
   */
  private attacEventListeners() {
    this.dom.ul.addEventListener('click', this.onMobileNavigationMenuClicked.bind(this))
  }

  /**
   * Called when a litte arror is clicked in mobile menu
   * @private
   * @param {Event} event click event
   */
  private onMobileNavigationMenuClicked(event:Event) {
    const eventTarget = event.target as HTMLElement;

    if( eventTarget.tagName === 'DIV' && eventTarget.classList.contains('button') ) {
      const menuItem = eventTarget.closest('li');
      const subMenuItems = menuItem.querySelector('nav.sub-menu-items') as HTMLElement;
      const show = subMenuItems.style.display !== 'block';
      subMenuItems.style.display = show ? 'block' : 'none';
      menuItem.classList.toggle('selected', show);
      menuItem.classList.toggle('arrow', show);
      menuItem.classList.toggle('expanded', show);
    }
  }


  /**
   * Toggle mobile navigation open or closed.
   * @param {boolean} [enabled] force show or hide menu, by default element is toggled
   */
  public static toggle(enabled = !document.body.classList.contains('mobile-menu-active')) {
    document.body.classList.toggle('mobile-menu-active', enabled);
  }

  /**
   * Initializes and bind logic in to DOM
   * @static
   */
  public static init() {
    document.querySelectorAll('.mobile-navigation').forEach( element => {
      new MobileNavigation( element as HTMLElement );
    });
  }
}

interface MobileNavigationDomElements {
  ul?: HTMLElement;
}
